import { useEffect, useState } from 'react';

export const ROUTES = ['home', 'summon', 'collection', 'team', 'adventures', 'missions', 'daily', 'quests', 'attributes', 'games', 'success', 'stats', 'settings'] as const;
export type RouteName = (typeof ROUTES)[number];

export interface Route {
  name: RouteName;
  /** Optional sub-path, e.g. `#/collection/weapons` → "weapons". */
  param?: string;
}

/** Hash routing keeps the build static-host friendly (05-architecture §4). */
export function parseHash(hash: string): Route {
  const [name, param] = hash.replace(/^#\/?/, '').split('/');
  const found = ROUTES.find((r) => r === name);
  return found ? { name: found, ...(param ? { param: decodeURIComponent(param) } : {}) } : { name: 'home' };
}

export function navigate(name: RouteName, param?: string): void {
  window.location.hash = `/${name}${param ? `/${encodeURIComponent(param)}` : ''}`;
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseHash(window.location.hash));
  useEffect(() => {
    const onChange = () => setRoute(parseHash(window.location.hash));
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}
